export const FbInstanceName = {
  PRIMARY: 'PRIMARY',
  SECONDARY: 'SECONDARY',
};
